/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Green_NotesInputs */

const en_green_notes = /** @type {(inputs: Green_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Green Notes`)
};

const es_green_notes = /** @type {(inputs: Green_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas de cafe verde`)
};

/**
* | output |
* | --- |
* | "Green Notes" |
*
* @param {Green_NotesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const green_notes = /** @type {((inputs?: Green_NotesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Green_NotesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_green_notes(inputs)
	return es_green_notes(inputs)
});